class ComboSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style id="base-styles">
        .combo-select {
          display: block;
          padding: 10px 12px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          text-transform: uppercase;
          font-size: 14px;
          letter-spacing: 1.8px;
        }
        .swatch {
          display: block;
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
          border-radius: 100%;
          border: 1px solid var(--anakiwa);
        }
        .options {
          display: none;
          position: absolute;
          top: calc(100% + 8px);
          left: 0;
          border: 1px solid var(--anakiwa);
          background: var(--primary-light);
          width: calc(100% - 2px);
          max-height: min-content;
          overflow: hidden;
          box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        }
        .options.open {
          display: block;
          z-index: 10;
        }
        .option {
          padding: 20px 24px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          text-transform: uppercase;
          font-size: 14px;
          letter-spacing: 1.8px;
          background: var(--primary-light);
        }
        .option:hover {
          background-color: var(--primary-dark);
          color: var(--primary-light);
        }
        select {
          display: none;
        }
      </style>
      <style id="custom-styles"></style>
      <div class="combo-select"></div>
      <div class="options"></div>
      <slot></slot>
    `;

    this.comboSelect = this.shadowRoot.querySelector('.combo-select');
    this.optionsContainer = this.shadowRoot.querySelector('.options');
    this.customStyles = this.shadowRoot.querySelector('#custom-styles');
  }

  static get observedAttributes() {
    return ['data-css'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-css') {
      this.applyCustomStyles();
    }
  }

  applyCustomStyles() {
    const customCSS = this.getAttribute('data-css') || '';
    this.customStyles.textContent = customCSS;
  }

  connectedCallback() {
    const realSelect = this.querySelector('select');
    if (!realSelect) {
      console.error('ComboSelect must wrap a real <select> element.');
      return;
    }

    //apply custom css
    this.applyCustomStyles();

    // Initialize the fake select with the real select's options.
    this._initializeOptions(realSelect);

    // Show options on fake select click.
    this.comboSelect.addEventListener('click', () => {
      this.optionsContainer.classList.toggle('open');
    });

    // Close dropdown when clicking outside.
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.optionsContainer.classList.remove('open');
      }
    });
  }

  _initializeOptions(realSelect) {
    // Set the initial display value to the real select's selected option.
    const initialValue = realSelect.options[realSelect.selectedIndex];
    this.comboSelect.innerHTML = `${initialValue.dataset.swatch ? `<img class="swatch" width="52" height="52" src="${initialValue.dataset.swatch}">` : ''} ${initialValue.textContent}`

    // Populate the options dropdown.
    Array.from(realSelect.options).forEach((option) => {
      const swatch = option.dataset.swatch;
      const comboOption = document.createElement('div');
      comboOption.classList.add('option');
      comboOption.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
      comboOption.dataset.value = option.value;

      // Update real select and fake select on option click.
      comboOption.addEventListener('click', () => {
        this.comboSelect.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
        realSelect.value = option.value;
        realSelect.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event.
        this.optionsContainer.classList.remove('open');
      });

      this.optionsContainer.appendChild(comboOption);
    });
  }
}

// Define the custom element.
customElements.define('combo-select', ComboSelect);